import { Component, OnInit, TemplateRef, ViewChild, AfterViewInit } from '@angular/core';

import { ReportService } from '../../../../../common/services/Report.service';
import { moment } from 'ngx-bootstrap/chronos/test/chain';
import { TicketService } from '../../../../../common/services/Ticket.service';
import { RoomService } from '../../../../../common/services/Room.service';
import { EvsUserService } from '../../../../../common/services/EvsUser.service';
import { TicketTypeService } from '../../../../../common/services/TicketType.service';
import { ServiceService } from '../../../../../common/services/Service.service';
import { PriorityService } from '../../../../../common/services/Priority.service';
import { GroupService } from '../../../../../common/services/Group.service';
import { UserService } from '../../../../../common/services/User.service';
import { ToastrService } from 'ngx-toastr';
import { ExportService } from '../../../../../common/services/Export.service';

declare var $: any;
declare var Chartist: any;

@Component({
  selector: 'report-service',
  templateUrl: 'service.template.html',
  styleUrls: ['../report.component.css'],
  providers: [
    ReportService,
    TicketService,
    GroupService,
    UserService,
    TicketTypeService,
    ServiceService,
    PriorityService,
  ],
})
export class ServiceComponent implements OnInit {
  public modelFilter: any = {};
  public list: Array<any> = [];
  public list_page_divide: Array<any> = [];
  public allStatus: Array<any> = [{ id: '', text: '' }];
  public allRoom: Array<any> = [{ id: '', text: '' }];
  public allAccount: Array<any> = [{ id: '', text: '' }];
  public allPriority: Array<any> = [{ id: '', text: '' }];
  public allService: Array<any> = [{ id: '', text: '' }];
  public allType: Array<any> = [{ id: '', text: '' }];
  public filterType = 'min';
  totalPage = 1;
  currentPage = 1;
  public exportData: any = [];

  constructor(
    private reportService: ReportService,
    private ticketService: TicketService,
    private groupService: GroupService,
    private userService: UserService,
    private ticketTypeService: TicketTypeService,
    private serviceService: ServiceService,
    private priorityService: PriorityService,
    private toastr: ToastrService,
    private exportService: ExportService
  ) {
    this.modelFilter = {
      from: moment().add('-30', 'days').format('YYYY-MM-DD HH:mm'),
      to: moment().format('YYYY-MM-DD HH:mm'),
    };
  }

  ngOnInit() {
    this.getStatus();
    this.loadService();
  }

  changeFilterType(type) {
    this.filterType = type;
    if (type == 'max') {
      this.getRooms();
      // this.getAccounts();
      this.getPriorities();
      this.getServices();
      this.getTypes();
      this.getStatus();
    } else {
      delete this.modelFilter.assign_agent_ids;
      delete this.modelFilter.assign_group_ids;
      delete this.modelFilter.type_ids;
      delete this.modelFilter.service_ids;
      delete this.modelFilter.priority_ids;
    }
  }

  refreshFilter() {
    delete this.modelFilter.assign_agent_ids;
    delete this.modelFilter.assign_group_ids;
    delete this.modelFilter.type_ids;
    delete this.modelFilter.service_ids;
    delete this.modelFilter.priority_ids;
    this.allAccount = [{ id: '', text: '' }];
  }

  getStatus() {
    this.ticketService.status().subscribe(res => {
      const statusList = [{ id: '', text: '' }];
      res.data.forEach((c: any) => {
        statusList.push({
          text: c.name,
          id: c.id,
        });
      });
      this.allStatus = statusList;
    });
  }

  getRooms() {
    this.groupService.allGroup({ target: 'user' }).subscribe(res => {
      const roomList = [{ id: '', text: '' }];
      res.data.forEach((c: any) => {
        roomList.push({
          text: c.name,
          id: c.id.toString(),
        });
      });
      this.allRoom = roomList;
    });
  }

  getAccounts(group_id) {
    if (group_id && group_id != '') {
      const where = {
        filters: JSON.stringify([
          {
            key: 'group_id',
            condition: '=',
            value: group_id,
          },
        ]),
      };
      this.userService.list(where).subscribe(res => {
        const staffList = [];
        res.data.list.forEach((c: any) => {
          staffList.push({
            text: c.name,
            id: c._id,
          });
        });
        this.allAccount = staffList;
      });
    }
  }

  getTypes() {
    this.ticketTypeService.allTicketType().subscribe(res => {
      const typeList = [];
      res.data.forEach((c: any) => {
        typeList.push({
          text: c.name,
          id: c.id,
        });
      });
      this.allType = typeList;
    });
  }

  getServices() {
    this.serviceService.allService().subscribe(res => {
      const serviceList = [];
      res.data.forEach((c: any) => {
        serviceList.push({
          text: c.name,
          id: c.id,
        });
      });
      this.allService = serviceList;
    });
  }

  getPriorities() {
    this.priorityService.allPriority().subscribe(res => {
      const priorityList = [];
      res.data.forEach((c: any) => {
        priorityList.push({
          text: c.name,
          id: c.id,
        });
      });
      this.allPriority = priorityList;
    });
  }

  changeTime(type) {
    let start: any = moment().format('YYYY-MM-DD HH:mm');
    const end: any = moment().format('YYYY-MM-DD HH:mm');
    switch (type) {
      case 'year': {
        // start = moment().startOf('year').format('YYYY-MM-DD HH:mm');
        start = moment().add('-365', 'days').format('YYYY-MM-DD HH:mm');
        break;
      }
      case 'month': {
        // start = moment().startOf('month').format('YYYY-MM-DD HH:mm');
        start = moment().add('-30', 'days').format('YYYY-MM-DD HH:mm');
        break;
      }
      case 'week': {
        // start = moment().startOf('isoWeek').format('YYYY-MM-DD HH:mm');
        start = moment().add('-7', 'days').format('YYYY-MM-DD HH:mm');
        break;
      }
      case 'day': {
        // start = moment().startOf('day').format('YYYY-MM-DD HH:mm');
        start = moment().add('-1', 'days').format('YYYY-MM-DD HH:mm');
        break;
      }
      case 'hour': {
        start = moment().add('-1', 'hours').format('YYYY-MM-DD HH:mm');
        break;
      }
      case 'minute': {
        start = moment().add('-30', 'minutes').format('YYYY-MM-DD HH:mm');
        break;
      }
      default:
        break;
    }
    this.modelFilter['from'] = start;
    this.modelFilter['to'] = end;
    this.loadService();
  }

  loadService() {
    this.reportService.reportService(this.modelFilter).subscribe(res => {
      this.list = res.data.result;
      this.totalPage =
        this.list.length % 10 != 0 ? Math.floor(this.list.length / 10) + 1 : Math.floor(this.list.length / 10);
      const begin = (this.currentPage - 1) * 10;
      const end = this.currentPage * 10;
      this.list_page_divide = this.list.slice(begin, end);
    });
  }

  submitFilter() {
    if (this.modelFilter.from) {
      this.modelFilter.from = moment(this.modelFilter.from).format('YYYY-MM-DD HH:mm');
    }
    if (this.modelFilter.to) {
      this.modelFilter.to = moment(this.modelFilter.to).format('YYYY-MM-DD HH:mm');
    }
    this.loadService();
  }

  public changeUser(e: any): void {
    this.modelFilter['assign_agent_ids'] = e.value;
  }

  public changeRoom(e: any): void {
    this.modelFilter['assign_group_ids'] = e.value;
    this.getAccounts(e.value);
  }
  public changeService(e: any): void {
    this.modelFilter['service_ids'] = e.value;
  }

  public changeType(e: any): void {
    this.modelFilter['type_ids'] = e.value;
  }
  public changePriority(e: any): void {
    this.modelFilter['priority_ids'] = e.value;
  }

  setPage(page: number) {
    if (page <= this.totalPage) {
      if (page < 1) {
        page = 1;
      }
      if (page != this.currentPage) {
        this.currentPage = page;
        this.loadService();
      }
    } else {
      page = this.totalPage;
      $('#inputPage').val(page);
      this.toastr.warning('Số trang tối đa hiện tại là ' + page, '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right',
      });
      if (page <= this.totalPage) {
        // this.pager = this.pagerService.getPager(this.totalRow, this.currentPage, this.page_size);
        if (page < 1) {
          page = 1;
        }
        if (page != this.currentPage) {
          this.currentPage = page;
          this.loadService();
        }
      }
    }
  }

  goPage2(toPage: any) {
    toPage = parseInt(toPage);
    if (toPage && toPage > 0) {
      this.setPage(toPage);
    }
  }

  export() {
    this.exportData = [];
    this.list.forEach(data => {
      const data_json: any = {};
      data_json['Dịch vụ'] = data.service_name;
      this.allStatus.forEach(e => {
        if (e.text != '') {
          data_json[e.text] = data.data[e.id];
        }
      });
      this.exportData.push(data_json);
    });
    this.exportService.exportExcel(
      this.exportData,
      'Báo cáo nhóm dịch vụ ' + moment(new Date()).format('YYYY-MM-DD HH-mm')
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/report/services/service.component.ts